import React from 'react';
import { Glasses } from 'lucide-react';
import { useStore } from '../store';

export default function LookbookButton() {
  const setLookbookOpen = useStore((state) => state.setLookbookOpen);
  const isModelAnimationComplete = useStore((state) => state.isModelAnimationComplete);

  const handleOpenLookbook = () => {
    setLookbookOpen(true);
  };

  if (!isModelAnimationComplete) {
    return null;
  }

  return (
    <button
      onClick={handleOpenLookbook}
      className="relative bg-[#9181B7] text-white px-8 py-2.5 rounded-lg 
        hover:bg-stone-600 transition-all duration-300 min-w-[250px]
        flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
    >
      <Glasses className="w-5 h-5" />
      lookbook
    </button>
  );
}